//所有与用户相关的请求全部存放在此文件中
import request from '../utils/request';
// 用户登录
const userLogin = (data) => request.post('/admin/admin/login', data);

export {
    userLogin,
}